import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { reflectionActions } from '../actions/reflection.actions';
import { ReflectionParams, ReflectionValue } from '../models';
import { selectLoaded, selectLoading, selectReflection, selectSaved, selectSaving } from '../selectors/reflection.selectors';
import { createKey } from '../utils/create-key';

@Injectable({
    providedIn: 'root',
})
export class ReflectionFacade {
    private readonly store = inject(Store);

    // Observable selectors
    readonly reflection$ = (id: string, params?: ReflectionParams) => this.store.select(selectReflection(createKey(id, params)));
    readonly reflectionNonNullable$ = (id: string, params?: ReflectionParams) => this.reflection$(id, params).pipe(filter((reflection) => reflection !== null));
    readonly loading$ = (id: string, params?: ReflectionParams) => this.store.select(selectLoading(createKey(id, params)));
    readonly loaded$ = (id: string, params?: ReflectionParams) => this.store.select(selectLoaded(createKey(id, params)));
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);

    // Signal selectors
    readonly reflection = (id: string, params?: ReflectionParams) => this.store.selectSignal(selectReflection(createKey(id, params)));
    readonly loading = (id: string, params?: ReflectionParams) => this.store.selectSignal(selectLoading(createKey(id, params)));
    readonly loaded = (id: string, params?: ReflectionParams) => this.store.selectSignal(selectLoaded(createKey(id, params)));
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);

    // Actions
    getReflection(id: string, params?: ReflectionParams): void {
        this.store.dispatch(reflectionActions.getReflection({ id, params }));
    }

    submitReflection(id: string, value: ReflectionValue): void {
        this.store.dispatch(reflectionActions.submitReflection({ id, value }));
    }

    clear(): void {
        this.store.dispatch(reflectionActions.clear());
    }
}
